import type { FeedAnchorsApiV4ResponseItem, FeedApiV4Response } from 'reactApp/api/FeedAPICall';
import type { FeedApiResponse, FeedItemBase } from 'reactApp/modules/feed/feed.types';
import type { ESortOder } from 'reactApp/modules/sort/sort.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export interface GalleryItem extends FeedItemBase {
    storage: EStorageType.gallery;
}

export enum GalleryCategoryType {
    all = 'all',
    desktop = 'desktop',
    mobile = 'mobile',
    images = 'images',
    videos = 'videos',
}

type timestamp = number;

export interface GalleryAnchor {
    id: string;
    periodStart: timestamp;
    periodEnd: timestamp;
    count: number;
    isLoading: boolean;
    isLoaded: boolean;
    cursor?: string;
    cursorOrder?: ESortOder;
}

export interface GalleryCategory {
    name: string;
    id: GalleryCategoryType;
    value: GalleryCategoryType;
    childs: string[];
    anchors: string[];
    cursor: string;
    isLoaded: boolean;
    isLoading: boolean;
    hasMoreToLoad: boolean;
}

export interface GalleryState {
    categories: GalleryCategory[];
    currentCategory: GalleryCategoryType;
    list: Record<string, GalleryItem>;
    currentFolder?: string;
    anchors: Record<string, GalleryAnchor>;
    targetAnchorId: string | null;
    activeAnchorId: string | null;
}

export interface GalleryLoadSuccessAction {
    category: GalleryCategoryType;
    data: { galleryListV2?: FeedApiResponse; galleryListV4?: FeedApiV4Response };
    folder?: string;
    isExactFolder?: boolean;
}

export interface GalleryAnchorsLoadRequestAction {
    category: GalleryCategoryType;
}

export interface GalleryAnchorsLoadSuccessAction {
    anchors: FeedAnchorsApiV4ResponseItem[];
}

export interface GalleryLoadCategoryRequestAction {
    category: GalleryCategoryType;
}

export interface GalleryLoadRequestAction {
    category: GalleryCategoryType;
}

export interface GalleryLoadAnchorListRequestAction {
    anchorId: string;
}

export interface GalleryLoadAnchorPaginatedListSuccessAction {
    anchorId: string;
    cursorOrder: ESortOder;
    data: FeedApiV4Response;
}

export interface GalleryLoadAnchorListSuccessAction {
    loadedAnchorIds: string[];
    data: FeedApiV4Response;
}

export interface GalleryLoadMoreSuccessAction {
    data: { galleryListV2?: FeedApiResponse; galleryListV4?: FeedApiV4Response };
    category?: GalleryCategoryType;
    folder?: string;
    isExactFolder?: boolean;
}

export interface ChangeGalleryFolderAction {
    category?: GalleryCategoryType;
    folder: string;
}

export interface GalleryAnchorsStatusAction {
    targetAnchorId: string | null;
    activeAnchorId: string | null;
}
